module.exports = __webpack_public_path__ + "assets/08423bff616caa62196556786c784b43.png";